<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><span aria-label="iv" class="page" epub:type="pagebreak" id="piv" role="doc-pagebreak"></span>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2023 by Samuel Weil Franklin</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2023</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">32 31 30 29 28 27 26 25 24 23     1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-65785-1 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-65799-8 (e-book)</p>
<p class="crt">DOI: <a class="url" href="https://doi.org/10.7208/chicago/9780226657998.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226657998.001.0001</a></p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Franklin, Samuel Weil, author.</p>
<p class="cip">Title: The cult of creativity : a surprisingly recent history / Samuel W. Franklin.</p>
<p class="cip">Description: Chicago : The University of Chicago Press, 2023. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2022037344 | ISBN 9780226657851 (cloth) | ISBN 9780226657998 (e-book)</p>
<p class="cip">Subjects: LCSH: Creative ability—United States. | Creation (Literary, artistic, etc.)</p>
<p class="cip">Classification: LCC BF408.F68 2023 | DDC 153.3/5—dc23/eng/20220825</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2022037344" target="_blank">https://lccn.loc.gov/2022037344</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI/NISO Z39.48-1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-franklin-0004.vue?a928ec66